import { 
    LOADING, 
    MENU_TOGGLE,
    BROADCAST_START,
    BROADCAST_END,
    OverlayAction,
    DIALOG_OPEN,
    DIALOG_CLOSE
} from "./types";
import { BroadcastType } from "./types";

export function loadingOverlay(value: boolean): OverlayAction
{
    return {
        type: LOADING,
        value: value
    }
}

export function broadcastMessage(message: string|JSX.Element, type?: BroadcastType): OverlayAction
{
    return {
        type: BROADCAST_START,
        value: {
            open: true,
            type: type,
            message: message
        }
    }
}

export function endBroadcastMessage(): OverlayAction
{
    return {
        type: BROADCAST_END,
        value: {
            open: false,
            message: ""
        }
    }
}

export function openDialog(content: JSX.Element): OverlayAction
{
    return {
        type: DIALOG_OPEN,
        value: {
            open: true,
            content: content
        }
    }
}

export function closeDialog(): OverlayAction
{
    return {
        type: DIALOG_CLOSE,
        value: {
            open: false,
            content: null
        }
    }
}

export function toggleMenu(): OverlayAction
{
    return {
        type: MENU_TOGGLE
    }
}